// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, DialogActions, TextField } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../../index'
import { updateEmplyeeNote } from './incentivesPanelQueries'
import css from './noteDialog.css'
type NoteDialogProps = {
  employee: any
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}
const defaultFormData = {
  body: '',
}

class NoteDialog extends React.PureComponent<NoteDialogProps> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { employee } = this.props

    if (employee.note) {
      this.setStateFromData({
        body: employee.note,
      })
    }
  }

  componentDidUpdate(prevProps: NoteDialogProps) {
    const { employee } = this.props

    if (employee.note !== prevProps.employee.note) {
      this.setStateFromData({
        body: employee.note,
      })
    }
  }

  setStateFromData = (note: any) => {
    this.setState({
      formData: { ...defaultFormData, ...note },
    })
  }
  onInput = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { employee, station } = this.props
    onMutate({
      variables: {
        stationId: station.id,
        userId: employee.user.id,
        note: this.state.formData.body,
        date: this.props.date,
      },
    })
    this.props.onClose()
  }
  onReset = () => {
    this.setState({
      formData: { ...defaultFormData },
    })
  }

  render() {
    const { isOpen, onClose } = this.props
    const { formData } = this.state
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>{i18n.t('employeeCard.addNote')}</DialogTitle>
        <DialogContent>
          <Mutation mutation={updateEmplyeeNote}>
            {(onMutate) => (
              <form onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.formComponent}>
                <TextField
                  autoFocus
                  required
                  label={i18n.t('noteDialog.label')}
                  value={formData.body}
                  onChange={(e) => this.onInput('body', e.target.value)}
                  className={css.textField}
                />
                <DialogActions className={css.actions}>
                  <Button type='button' onClick={() => onClose()}>
                    {i18n.t('buttons.cancel')}
                  </Button>
                  <Button type='submit' color='primary'>
                    {i18n.t('buttons.save')}
                  </Button>
                </DialogActions>
              </form>
            )}
          </Mutation>
        </DialogContent>
      </Dialog>
    )
  }
}

export default NoteDialog
